import React, {useEffect, useRef} from 'react';
import mainStyles from 'components/homeParallax/HomeParallax.module.scss';
import styles from './Content.module.scss'
import macroStyles from "components/homePanels/f-i_macroPage/MacroPage.module.scss";
import Splitting from 'splitting';
import {gsap, TimelineMax, TweenMax} from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollMagic from "scrollmagic";
import layerStyles from "components/homePanels/f-i_macroPage/heroLayers/Layers.module.scss";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
gsap.registerPlugin(ScrollTrigger);

const Content = (props) => {

    const content = useRef();
    const title = useRef();
    const description = useRef();

    useEffect(()=>{

        let timeout = setTimeout(()=>{

            let controller = new ScrollMagic.Controller({
                container: props.scroller
            });

            let timeline = new TimelineMax();
            let elements = [];

            let titleText = TweenMax.fromTo(title.current, { opacity: 0, top: 50}, {delay: 0.5, opacity: 1, top: 0});
            elements.push(titleText);

            let lines = Splitting({target: description.current, by: 'lines'});
            let time = 0.5;

            if (lines && lines[0]) lines[0].lines.forEach((line) => {
                line.forEach((item) => {
                    let line = TweenMax.fromTo(item, {opacity: 0, top: 50,}, { delay: time, opacity: 1, top: 0});
                    elements.push(line);
                })
                time = time + .2;
            })

            timeline.add(elements);

            new ScrollMagic.Scene({
                reverse: true,
                triggerElement: content.current,
                triggerHook: 'onEnter',
                duration: '50%'})
                .setTween(elements)
                .addTo(controller);


        }, 200);

        return ()=>clearTimeout(timeout)

    },[props.scroller])

    function buildBgLayers(){


        if(props.macro === 'martellus'){
            return (
                <>
                    <div className={layerStyles.martellus_content}>
                        <ImageWrapper aria-hidden={true} className={layerStyles.martellus_contentCloudLeft} set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-content-left-flower-clouds.jpg'}} alt={'Flower Cloud Left'}/>
                        <ImageWrapper aria-hidden={true} className={layerStyles.martellus_contentBee} set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-bonus-bee.png'}} alt={'Bee'}/>
                        <ImageWrapper aria-hidden={true} className={layerStyles.martellus_contentCloudRight} set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-content-right-flower-clouds.jpg'}} alt={'Flower Cloud Right'}/>
                    </div>

                </>
            )
        }
    }

    return (
        <div ref={content} className={`${macroStyles.macroPanel} ${styles.contentWrapper}`}>
            {buildBgLayers()}
            <div className={styles.content}>
                <h4 ref={title} dangerouslySetInnerHTML={{__html:props.content.title}}/>

                <p className={mainStyles.accessibleContent} dangerouslySetInnerHTML={{__html:props.content.description}}/>
                <span aria-hidden={true}><p ref={description} dangerouslySetInnerHTML={{__html:props.content.description}}/></span>

            </div>
        </div>
    )
};

export default Content
